export default __webpack_public_path__ + "static/media/sd.8df6ee83.svg";